import customer from '../../../api/profile/customer'

import { getField, updateField } from 'vuex-map-fields'

// initial state
const state = {
  addressList: [],
  newAddress: {
    CustomersAddressId: 0,
    FullName: '',
    MobileNo: '',
    PostalCode: '',
    UnitNo: '',
    Address: '',
    BuildingName: '',
    IsDefault: false
  },
  selectedAddress: {},
  info: {}
}

// getters
const getters = {
  getField,
  info: (state, getters) => {
    return state.info
  }
}

// actions
const actions = {
  getAddressList ({ commit }) {
    return new Promise((resolve, reject) => {
      customer.getAddressList()
        .then(res => {
          commit('setAddressList', res)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  selectAddress ({ commit }, address) {
    commit('selectAddress', address)
  },
  addAddress ({ commit, state }) {
    if (state.newAddress.FullName === '') {
      return new Promise((resolve) => {
        resolve()
      })
    }
    const data = JSON.parse(JSON.stringify(state.newAddress))
    return new Promise((resolve, reject) => {
      customer.addAddress(data)
        .then(res => {
          data.CustomersAddressId = res.CustomersAddressId
          commit('addNewAddress', data)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  editAddress ({ commit, state }, address) {
    return new Promise((resolve, reject) => {
      customer.editAddress(address)
        .then(res => {
          commit('editAddress', address)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeAddress ({ commit, state }, address) {
    const data = {
      CustomersAddressId: address.CustomersAddressId
    }
    return new Promise((resolve, reject) => {
      customer.removeAddress(data)
        .then(res => {
          commit('removeAddress', data)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCustomerInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      customer.getCustomerInfo()
        .then(res => {
          commit('setCustomerInfo', res)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  editCustomerInfo ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      customer.editCustomerInfo(data)
        .then(res => {
          commit('editCustomerInfo', data)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  editCustomerPassword ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      customer.editCustomerPassword(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  customerCredit ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      customer.customerCredit(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  customerPointsPaging ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      customer.customerPointsPaging(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  updateField,
  setAddressList (state, res) {
    if (state.selectedAddress.CustomersAddressId === null || state.selectedAddress.CustomersAddressId === undefined || state.selectedAddress.CustomersAddressId < 1) {
      const defaultAdd = res.Addresses.filter(a => a.IsDefault === true)
      if (defaultAdd != null && defaultAdd.length > 0) {
        state.selectedAddress = defaultAdd[0]
      } else {
        // state.selectedAddress = res.Addresses[0]
      }
    }
    state.addressList = res.Addresses
  },
  selectAddress (state, address) {
    state.addressList.map(a => {
      a.IsDefault = false
      return a
    })
    state.selectedAddress = address
    state.addressList.filter(a => a.CustomersAddressId === address.CustomersAddressId)[0].IsDefault = true
  },
  addNewAddress (state, res) {
    state.newAddress = {
      CustomersAddressId: 0,
      FullName: '',
      MobileNo: '',
      PostalCode: '',
      UnitNo: '',
      Address: '',
      BuildingName: '',
      IsDefault: false
    }
    res.IsDefault = true
    state.addressList.push(res)
    state.selectedAddress = res
  },
  removeAddress (state, data) {
    const address = state.addressList.filter(a => a.CustomersAddressId === data.CustomersAddressId)
    if (address[0].CustomersAddressId === state.selectedAddress.CustomersAddressId) {
      state.selectedAddress = null
    }
    if (address !== null && address.length > 0) {
      const index = state.addressList.indexOf(address[0])
      if (index > -1) {
        state.addressList.splice(index, 1)
      }
    }
  },
  editAddress (state, data) {
    const address = state.addressList.filter(a => a.CustomersAddressId === data.CustomersAddressId)
    if (address !== null) {
      address[0].Address = data.Address
      address[0].BuildingName = data.BuildingName
      address[0].CustomersAddressId = data.CustomersAddressId
      address[0].FullName = data.FullName
      address[0].IsDefault = data.IsDefault
      address[0].MobileNo = data.MobileNo
      address[0].PostalCode = data.PostalCode
      address[0].UnitNo = data.UnitNo
    }
  },
  setCustomerInfo (state, data) {
    state.info = data
  },
  editCustomerInfo (state, data) {
    state.info.FullName = data.FullName
    state.info.Email = data.Email
    state.info.ContacctNo = data.ContacctNo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile/customer.js